import classNames from "classnames";
// packages
import { useTranslation } from "react-i18next";
// components
import Pill from "../../common/Pill";
// styles
import styles from "./broker.module.scss";

interface Props {
  text?: string;
}

const Broker = ({ text }: Props) => {
  const { t } = useTranslation();
  return (
    <Pill
      styleName="brokerBg"
      Lefticon={<img src="../../../assets/images/svg/brokerStatus.svg" />}>
      <p className={classNames(styles.buyText, "p2")}>
        {text ? text : `${t("lbl_broker")}`}
      </p>
    </Pill>
  );
};

export default Broker;
